export const sanitizeSvg = (svgText: string): SVGSVGElement | null => {

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, "image/svg+xml");

    const svg = doc.querySelector("svg");
    if (!svg) {
      console.error("[SVG] SANITIZE FAILED → no <svg>");
      return null;
    }


    const removed = doc.querySelectorAll("script, foreignObject");
    removed.forEach((r) => r.remove());

    return svg as SVGSVGElement;
  } catch (e) {
    console.error("[SVG] SANITIZE ERROR:", e);
    return null;
  }
};
